import { useMutation } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { useCallback, useState } from 'react'

import { DirtyFile, ExistingFile } from '../types'
import { cleanCaptions } from '../utils/captions'

export default function useUpdateDirtyFile(): [
  (file: DirtyFile) => Promise<ExistingFile>,
  boolean
] {
  const [loading, setLoading] = useState(false)
  const [updateMutation] = useMutation(AdminAPI.file.UPDATE)

  const update = useCallback(
    (file: DirtyFile) => {
      setLoading(true)

      return updateMutation({
        variables: {
          input: {
            id: file.id,
            captions: file.captions ? cleanCaptions(file.captions) : undefined,
            alwaysMute: file.alwaysMute,
            altText: file.altText,
            translations: file.translations
          }
        }
      })
        .then(({ data, errors }) => {
          if (!data) return Promise.reject(errors)

          const file = getFragment(
            SharedAPI.file.FILE_FRAGMENT,
            data.updateFile
          )

          return Promise.resolve(file)
        })
        .finally(() => setLoading(false))
    },
    [updateMutation, setLoading]
  )

  return [update, loading]
}
